import React from "react";
import { useParams } from "react-router-dom";
import WalletManagement from "../../components/WhatsApp/Wallet/WalletManagement";

const WalletDashboard = () => {
  const { businessId } = useParams();

  return <WalletManagement businessId={businessId} />;
};

export default WalletDashboard;
